import { RegisterResponse } from '../../../../../types/api/endpoints/auth/register.types';
import { COMMERCIAL_ENDPOINTS } from '../../../../../utils/api/endpoints/commercialEndpoints';

const PREFIX = '[uploadInvoiceQuery]';

export const UPLOAD_INVOICE_QUERY_KEY = 'UPLOAD_INVOICE';

export const uploadInvoiceQuery = async (data: FormData) => {
  console.log(PREFIX, `Requesting invoice uploading...`);

  const response = await COMMERCIAL_ENDPOINTS.uploadInvoice2(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received invoice.`);
  return json as RegisterResponse;
};
